import { inject } from '@angular/core';
import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { environment } from 'environments/environment';
import { ErrorEnum } from './errorEnum';
import { PathEnum } from 'app/enums/pathEnum';

/**
 * Intercept errors from Backend
 *
 * @param req
 * @param next
 */
export const errorInterceptor: HttpInterceptorFn = (req, next) => 
{
    
    const _router = inject(Router);

    // Clone the request object
    let newReq = req.clone();

    // Add token and error management only for request targeting our backend
    if ( req.url.startsWith(environment.api) ) {
        // Response
        return next(newReq).pipe(
            catchError((error) => {

                    // Catch "400" functional error responses
                    if ( error instanceof HttpErrorResponse && error.status === 400)
                    {
                        // Redirect erros
                        if(error.error.details[0] === ErrorEnum.F_EXCEPTION_ESTABLISHMENT_NOT_FOUND){
                            _router.navigate([PathEnum.ERROR, PathEnum.ERROR_MENU_404]);
                        
                        }
                    } 
                    return throwError(error);
                })
        );
        } else {
            return next(newReq);
    }
}
